/** Hero section id — authoritative initial active section. */
export const HERO_SECTION_ID = "#hero";

/** Show the travelling overlay (and hide in-layout `.genie-static` poses). */
export const setGenieTravellerLive = (live) => {
    document.documentElement.classList.toggle("genie-live", Boolean(live));
};

/**
 * Run callback once the base pose image has dimensions (cached, load, or decode).
 * No timers or polling — uses the browser image lifecycle only.
 */
export const whenBasePoseReady = (posesRef, onReady) => {
    const img = posesRef.current[0];
    if (!img) {
        onReady();
        return;
    }

    if (img.complete && img.naturalWidth > 0) {
        onReady();
        return;
    }

    let settled = false;
    const finish = () => {
        if (settled) return;
        settled = true;
        onReady();
    };

    img.addEventListener("load", finish, { once: true });
    img.addEventListener("error", finish, { once: true });

    if (typeof img.decode === "function") {
        img.decode().then(finish).catch(finish);
    }
};

/** True when Hero init should still run (user has not left Hero mid-load). */
export const shouldApplyHeroInit = (currentSectionId, isTransitioning) =>
    currentSectionId === HERO_SECTION_ID && !isTransitioning;
